import type { ButtonHTMLAttributes, FC } from 'react';

import { cn } from './cn.js';

export type ButtonVariant = 'default' | 'primary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

/*
 * Варианты - обычные map-объекты, без class-variance-authority: осей всего две и
 * значений в них немного, абстракция себя не окупает. Размеры взяты из макета
 * (.btn / .btn.sm / .btn.lg в design-source/styles.css).
 */
const VARIANT: Record<ButtonVariant, string> = {
  default: 'border border-ink-200 bg-white text-ink-800 hover:bg-ink-100',
  primary:
    'border border-brand-green bg-brand-green text-white shadow-sm hover:bg-brand-green-600',
  ghost:
    'border border-transparent bg-transparent text-ink-700 hover:bg-ink-100',
  danger:
    'border border-ink-200 bg-white text-st-delayed hover:border-st-delayed-bg hover:bg-st-delayed-bg',
};

const SIZE: Record<ButtonSize, string> = {
  sm: 'h-7 gap-1.5 rounded-md px-2.5 text-xs',
  md: 'h-[34px] gap-1.5 rounded-[7px] px-3.5 text-[13px]',
  lg: 'h-10 gap-2 rounded-[7px] px-[18px] text-sm',
};

const BASE =
  'inline-flex shrink-0 cursor-pointer items-center justify-center whitespace-nowrap font-[550] ' +
  'transition-colors focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ' +
  'focus-visible:outline-none disabled:pointer-events-none disabled:opacity-40 ' +
  '[&_svg]:size-4 [&_svg]:shrink-0';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export const Button: FC<ButtonProps> = ({
  variant = 'default',
  size = 'md',
  className,
  type = 'button',
  ...rest
}) => (
  <button
    type={type}
    className={cn(BASE, VARIANT[variant], SIZE[size], className)}
    {...rest}
  />
);
